import { List } from 'immutable';

import { ComponentLibraryModule } from '@opengov/component-library-classic/module';
import { FeatureFlagModule } from '@opengov/feature-flag';

import { effects } from './effects';
import { middleware } from './middleware';
import { exportModule } from './module';
import { state } from './state';

export { Entity } from './entity';

export const AppCoreModule = exportModule({
  state,
  effects,
  middleware,
  dependencies: List([ComponentLibraryModule, FeatureFlagModule])
});
